import { 
	GET_ALL_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
	GET_MY_WORKPACKAGES_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
	GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGES, 
	GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
	CREATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
	UPDATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
	DESTROY_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
} from "./actions"

export function ProjectDrawingOfficeWorkPackagesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGES}_FULFILLED`:
		case `${GET_ALL_PROJECT_DRAWING_OFFICE_WORK_PACKAGES}_FULFILLED`:
		case `${GET_MY_WORKPACKAGES_PROJECT_DRAWING_OFFICE_WORK_PACKAGES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:
		case `${CREATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:
		case `${UPDATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectDrawingOfficeWorkPackagesReducer } from "modules/project/drawing_office/work_packages/reducer"

// project_drawing_office_work_packages:ProjectDrawingOfficeWorkPackagesReducer,
